module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"add-group-label":"Ajouter la carte","show-detail-group":"Afficher le contenu de la carte","hide-detail-group":"Masquer le contenu de la carte"}}')
  delete Component.options._Ctor
}
